import "./ModuleLoader.css";

/**
 * Suspense fallback for lazy-loaded dashboards. Renders a themed skeleton of a generic dashboard
 * layout (title → KPI cards → section blocks) with a shimmer, so switching modules fades into
 * placeholder "sections" instead of a bare unstyled "Loading..." line.
 */
export default function ModuleLoader({ name }) {
  return (
    <div className="mldr" role="status" aria-live="polite" aria-busy="true">
      <div className="mldr-head">
        <div className="mldr-sk mldr-title" />
        <div className="mldr-sk mldr-sub" />
      </div>

      <div className="mldr-grid">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="mldr-sk mldr-card" />
        ))}
      </div>

      <div className="mldr-sk mldr-section" />
      <div className="mldr-sk mldr-section tall" />

      <div className="mldr-status">
        <span className="mldr-spinner" aria-hidden="true" />
        Loading {name || "dashboard"}…
      </div>
    </div>
  );
}
